import React from 'react';
import { PARTNER_SEX } from '../../../../constants/partner';
import formatString from '../../../../utilities/format-string';

const PromissoryNoteTemplate = ({
  totalAmount,
  isGroup,
  borrowerName,
  address,
  sex,
}) => {
  const config = JSON.parse(localStorage.getItem('Config'));

  const subjectBorrowerName = isGroup ? (
    <>
      las integrantes del grupo <b>{borrowerName}</b> reconocemos deber y nos
      obligamos pagar
    </>
  ) : (
    <>
      yo{' '}
      {(sex === PARTNER_SEX.WOMAN && 'la') || (sex === PARTNER_SEX.MAN && 'el')}{' '}
      C. <b>{borrowerName}</b> reconozco deber y me obligo a pagar
    </>
  );

  const subjectSubscriber = isGroup
    ? 'Los suscriptores'
    : (sex === PARTNER_SEX.WOMAN && 'La suscriptora') ||
      (sex === PARTNER_SEX.MAN && 'El suscriptor');

  return (
    <>
      <div>
        <p className="text-right">
          <b>PAGARÉ</b>
        </p>
      </div>
      <div>
        <p className="text-right">
          BUENO POR: <b>{totalAmount}</b>
        </p>
      </div>
      <div>
        <p>
          Por el presente pagaré {subjectBorrowerName} incondicionalmente y
          solidariamente a la orden de SOLFIN DEL SURESTE S.A.S. DE C.V., a la
          vista sin protesto previo de este documento, la cantidad de{' '}
          <b>{totalAmount}</b>, en {address} o en cualquier otra plaza en que se
          me requiera de pago a elección del beneficiario de este título, valor
          que fue recibido, a la entera satisfacción del suscriptor.
        </p>
      </div>
      <div>
        <p>
          De no cubrirse el pago íntegro de la cantidad que ampara este título,
          el saldo insoluto del mismo devengará, en la medida que lo permita la
          ley aplicable, intereses moratorios a una tasa de interés del{' '}
          {config.percentageDelinquency}% (
          <span className="text-lowercase">
            {formatString.converTensToLetters(config.percentageDelinquency)}
          </span>{' '}
          por ciento) mensual sobre el monto total otorgado.
        </p>
      </div>
      <div>
        <p>
          {subjectSubscriber} de este pagaré {isGroup ? 'aceptan' : 'acepta'}{' '}
          que se amplíe el plazo de presentación de este documento a que se
          refiere el artículo 128 de la Ley General de Títulos y Operaciones de
          Crédito hasta 48 (cuarenta y ocho) meses posteriores contados a partir
          de esta fecha.
        </p>
      </div>
      <div>
        <p>
          {subjectSubscriber} y cualquier obligado cambiario posterior se
          someten indubitablemente a las leyes y tribunales aplicables y
          competentes de Tuxtla Gutiérrez, Chiapas, renunciando a cualquier
          fuero que pudiera corresponderles por razón de su domicilio presente,
          futuro o por cualquier otra causa.
        </p>
      </div>
    </>
  );
};

export default PromissoryNoteTemplate;
